module.exports = __webpack_public_path__ + "register/img/paw_print.0909ba3c.png";